import CloseUps from '../../src/legacy/CloseUps';
export default CloseUps;
